import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import TextBox from '../../../../../components/common/TextBox';
import ColorButton from '../../../../../components/common/ColorButton';
import FlexLayout from '../../../../../components/common/FlexLayout';
import ApplyButton from '../../../../../components/common/ApplyButton';
import ImageCarousel from '../../../../../components/common/ImageCarousel';
import { availableHotspots } from '../../../../../utils/tshirtHotspots';

const Angle = ({
  options,
  initialSelectedCustomizationIndex,
  selectedPart,
  partsConfig,
  updatePartsConfig,
  allCategoryCustomizations,
  tShirtBikeFrontNumberPlate,
  tShirtBikeBackNumberPlate,
  tShirtBikeFrontText,
  tShirtBikeBackText,
  setCurrentText,
  setIsConfigSaved,
  currentActiveParent,
  bikeTextData,
  allBikeArtData,
  currentText,
  setFrontBikeNumberPlate,
  setBackBikeNumberPlate,
  setFrontBikeText,
  setBackBikeText,
  selectedAngle
}) => {
  // const [activeColor, setActiveColor] = useState(
  //   initialSelectedCustomizationIndex
  // );

  const [numberPlate, setNumberPlate] = useState(
    currentActiveParent === 'front'
      ? tShirtBikeFrontNumberPlate.text[0].line
      : tShirtBikeBackNumberPlate.text[0].line
  );

  const [bikeText, setBikeText] = useState(
    currentActiveParent === 'front'
      ? tShirtBikeFrontText[0].line
      : tShirtBikeBackText[0].line
  );

  const models = allBikeArtData
    .filter(cust => cust.customizationType === 'model')
    .map(entry => entry.partId);

  const selectedModel = Object.keys(partsConfig.bikeArt).find(
    key => models.includes(key) && partsConfig.bikeArt[key] === true
  );

  const colors = allBikeArtData
    .filter(cust => cust.customizationType === 'color')
    .map(entry => entry.partId);

  const selectedColor = Object.keys(partsConfig.bikeArt).find(
    key => colors.includes(key) && partsConfig.bikeArt[key] === true
  );

  useEffect(() => {
    setNumberPlate(
      currentActiveParent === 'front'
        ? tShirtBikeFrontNumberPlate.text[0].line
        : tShirtBikeBackNumberPlate.text[0].line
    );
    setBikeText(
      currentActiveParent === 'front'
        ? tShirtBikeFrontText[0].line
        : tShirtBikeBackText[0].line
    );
  }, [currentActiveParent]);

  const placements = allBikeArtData
    .filter(cust => cust.customizationType === 'placement')
    .map(entry => entry.partId);

  const selectedPlacementPartId = Object.keys(partsConfig.bikeArt).find(
    key => placements.includes(key) && partsConfig.bikeArt[key] === true
  );
  const selectedPlacement = selectedPlacementPartId
    ? allBikeArtData.find(cust => cust.partId === selectedPlacementPartId)
    : allBikeArtData.filter(cust => cust.customizationType === 'placement')[0];

  const availablePlate = options.filter(option =>
    option.partId.match(/BN\d{4}[F|B]/i)
  )[0];

  // useEffect(() => {
  //   let availableNumberPlate = availablePlate;
  //   if (currentActiveParent === 'front') {
  //     availableNumberPlate = allBikeArtData
  //       .filter(cust => cust.partId.match(/BN\d{4}F/i))
  //       .find(
  //         entry =>
  //           entry.partId[entry.partId.length - 1] === 'F' &&
  //           entry.dependencies.parts.includes(selectedAngle)
  //       );
  //     if (availableNumberPlate)
  //       setFrontBikeNumberPlate(
  //         numberPlate,
  //         availableNumberPlate.configData.uOffset,
  //         availableNumberPlate.configData.vOffset,
  //         availableNumberPlate.configData.fontSize
  //       );
  //   } else {
  //     availableNumberPlate = allBikeArtData
  //       .filter(cust => cust.partId.match(/BN\d{4}B/i))
  //       .find(
  //         entry =>
  //           entry.partId[entry.partId.length - 1] === 'B' &&
  //           entry.dependencies.parts.includes(selectedAngle)
  //       );
  //     if (availableNumberPlate)
  //       setBackBikeNumberPlate(
  //         numberPlate,
  //         availableNumberPlate.configData.uOffset,
  //         availableNumberPlate.configData.vOffset,
  //         availableNumberPlate.configData.fontSize
  //       );
  //   }
  //   if (availableNumberPlate)
  //     updatePartsConfig(
  //       availableNumberPlate,
  //       'bikeArt',
  //       allBikeArtData.map(cust => cust.partId)
  //     );
  // }, [selectedAngle, selectedModel, selectedColor]);

  return (
    <div className="angle">
      <div className="angle_top">
        <ImageCarousel
          items={options.filter(
            entry =>
              !entry.partId.match(/BN\d{4}[F|B]/i) &&
              !entry.partId.match(/TXT\d{3}[F|B]/i)
          )}
          allBikeArtData={allBikeArtData}
          selectedAngle={selectedAngle}
          updatePartsConfig={updatePartsConfig}
          allCategoryCustomizations={allCategoryCustomizations}
          currentActiveParent={currentActiveParent}
        />
      </div>
      <div className="angle_bottom">
        <div className="angle_text">
          <TextBox
            name="text-1"
            placeholder="type your text"
            maxLength={15}
            value={bikeText}
            onChange={value => {
              setBikeText(value);
            }}
          />
        </div>
        <div
          className="angle_text_btn"
          style={
            currentActiveParent === 'front'
              ? {
                  opacity: bikeText === tShirtBikeFrontText[0].line ? 0.3 : 1
                }
              : {
                  opacity: bikeText === tShirtBikeBackText[0].line ? 0.3 : 1
                }
          }
        >
          <ApplyButton
            label="apply"
            disabled={
              currentActiveParent === 'front'
                ? bikeText === tShirtBikeFrontText[0].line
                : bikeText === tShirtBikeBackText[0].line
            }
            onClick={() => {
              if (currentActiveParent === 'front') {
                setFrontBikeText(bikeText);
                updatePartsConfig(
                  options.filter(option =>
                    option.partId.match(/TXT\d{3}F/i)
                  )[0],
                  'bikeArt',
                  allBikeArtData.map(cust => cust.partId)
                );
              } else {
                setBackBikeText(bikeText);
                if (selectedPlacement)
                  updatePartsConfig(
                    selectedPlacement,
                    'bikeArt',
                    allBikeArtData
                      .filter(cust => cust.customizationType !== 'placement')
                      .map(cust => cust.partId)
                  );
              }
            }}
          />
        </div>
        <div className="angle_text">
          <TextBox
            name="text-2"
            placeholder="type your number plate"
            maxLength={13}
            value={numberPlate}
            onChange={value => {
              setNumberPlate(value);
            }}
          />
        </div>
        <div
          className="angle_text_btn"
          style={
            currentActiveParent === 'front'
              ? {
                  opacity:
                    numberPlate === tShirtBikeFrontNumberPlate.text[0].line
                      ? 0.3
                      : 1
                }
              : {
                  opacity:
                    numberPlate === tShirtBikeBackNumberPlate.text[0].line
                      ? 0.3
                      : 1
                }
          }
        >
          <ApplyButton
            label="apply"
            disabled={
              currentActiveParent === 'front'
                ? numberPlate === tShirtBikeFrontNumberPlate.text[0].line
                : numberPlate === tShirtBikeBackNumberPlate.text[0].line
            }
            onClick={() => {
              const availablePlateToUpdate = allCategoryCustomizations.filter(
                plate => plate.dependencies.parts.includes(selectedAngle)
              )[0];
              const bike = options.find(part =>
                part.partId.match(/BC\d{4}[F\B]/i)
              ).configData.linkBack.model;
              const bikeCode = bike.substring(4);
              const viewCode = currentActiveParent === 'front' ? 'F' : 'B';
              // const regex = new RegExp(`/BN${bikeCode}01${viewCode}/i`);
              const defaultPlatePartId = `BN${bikeCode}01${viewCode}`;
              const defaultFirstPlate = allBikeArtData.find(
                plate => plate.partId === defaultPlatePartId
              );
              if (currentActiveParent === 'front') {
                if (availablePlateToUpdate)
                  setFrontBikeNumberPlate(
                    numberPlate,
                    availablePlateToUpdate.configData.uOffset,
                    availablePlateToUpdate.configData.vOffset,
                    availablePlateToUpdate.configData.fontSize,
                    availablePlateToUpdate.configData.width
                  );
                else setFrontBikeNumberPlate(numberPlate, 0, 0, 20, 0);
              } else {
                if (availablePlateToUpdate)
                  setBackBikeNumberPlate(
                    numberPlate,
                    availablePlateToUpdate.configData.uOffset,
                    availablePlateToUpdate.configData.vOffset,
                    availablePlateToUpdate.configData.fontSize,
                    availablePlateToUpdate.configData.width
                  );
                else setBackBikeNumberPlate(numberPlate, 0, 0, 20, 0);
              }

              updatePartsConfig(
                availablePlateToUpdate || defaultFirstPlate,
                'bikeArt',
                allBikeArtData.map(cust => cust.partId)
              );
            }}
          />
        </div>
      </div>
    </div>
  );
};

Angle.propTypes = {
  options: PropTypes.array,
  initialSelectedCustomizationIndex: PropTypes.number,
  updatePartsConfig: PropTypes.func,
  setCurrentText: PropTypes.func,
  currentText: PropTypes.array
};

export default Angle;
